import React from 'react';
import Layout from '../components/Layout';

const cardStyle = {
  maxWidth: 600,
  margin: '3rem auto',
  background: 'linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%)',
  borderRadius: 18,
  boxShadow: '0 4px 24px 0 rgba(0, 200, 83, 0.12)',
  padding: '3rem 2.5rem',
  textAlign: 'center',
  border: '1.5px solid #A5D6A7',
};

const headingStyle = {
  color: '#1B5E20',
  fontSize: 36,
  fontWeight: 800,
  marginBottom: 16,
  letterSpacing: 1.2,
  textShadow: '0 2px 8px rgba(0, 200, 83, 0.08)',
};

const subText = {
  color: '#388E3C',
  fontSize: 20,
  marginBottom: 0,
  fontWeight: 500,
  opacity: 0.85,
};

const DashboardPage = () => (
  <Layout>
    <div style={cardStyle}>
      <h2 style={headingStyle}>Welcome to JewellERP Dashboard!</h2>
      <p style={subText}>Your luxury jewelry business, beautifully managed.</p>
    </div>
  </Layout>
);

export default DashboardPage; 